// constants
import { ClubActionTypes } from './constants';
import Club, { ClubExtraInfo } from './model';

export interface ClubActionType {
    type:
        | ClubActionTypes.API_RESPONSE_SUCCESS
        | ClubActionTypes.API_RESPONSE_ERROR
        | ClubActionTypes.GET_CLUBS
        | ClubActionTypes.FIND_CLUB
        | ClubActionTypes.CREATE_CLUB
        | ClubActionTypes.UPDATE_CLUB
        | ClubActionTypes.UPDATE_CLUB_EXTRA_INFO
        | ClubActionTypes.RENEW_CLUB;
    payload: {} | string;
}

// common success
export const clubsApiResponseSuccess = (actionType: string, data: Club | Club[] | {} | []): ClubActionType => ({
    type: ClubActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const clubsApiResponseError = (actionType: string, error: string): ClubActionType => ({
    type: ClubActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getClubs = (includeExtraInfo: boolean = false): ClubActionType => ({
    type: ClubActionTypes.GET_CLUBS,
    payload: { includeExtraInfo },
});

export const findClub = (clubId: number, includeExtraInfo: boolean = false): ClubActionType => ({
    type: ClubActionTypes.FIND_CLUB,
    payload: { id: clubId, includeExtraInfo },
});

export const createClub = (club: Club): ClubActionType => ({
    type: ClubActionTypes.CREATE_CLUB,
    payload: club,
});

export const updateClub = (club: Club): ClubActionType => ({
    type: ClubActionTypes.UPDATE_CLUB,
    payload: club,
});

export const updateClubExtraInfo = (clubExtraInfo: ClubExtraInfo): ClubActionType => ({
    type: ClubActionTypes.UPDATE_CLUB_EXTRA_INFO,
    payload: clubExtraInfo,
});

export const renewClub = (club: Club): ClubActionType => ({
    type: ClubActionTypes.RENEW_CLUB,
    payload: club,
});
